export const GET_ENGINEERING_TIME_ENTRIES = 'GET_ENGINEERING_TIME_ENTRIES';
export const GET_ENGINEERING_TIME_ENTRIES_SUCCESS =
  'GET_ENGINEERING_TIME_ENTRIES_SUCCESS';
export const GET_ENGINEERING_TIME_ENTRIES_ERROR =
  'GET_ENGINEERING_TIME_ENTRIES_ERROR';

export const CREATE_ENGINEERING_TIME_ENTRY_SUCCESS =
  'CREATE_ENGINEERING_TIME_ENTRY_SUCCESS';
export const CREATE_ENGINEERING_TIME_ENTRY_ERROR =
  'CREATE_ENGINEERING_TIME_ENTRY_ERROR';

export const UPDATE_ENGINEERING_TIME_ENTRY_SUCCESS =
  'UPDATE_ENGINEERING_TIME_ENTRY_SUCCESS';
export const UPDATE_ENGINEERING_TIME_ENTRY_ERROR =
  'UPDATE_ENGINEERING_TIME_ENTRY_ERROR';

export const ADD_ENGINEERING_ENTRY = 'ADD_ENGINEERING_ENTRY';
export const DELETE_ENGINEERING_ENTRY = 'DELETE_ENGINEERING_ENTRY';
export const REVERT_ENGINEERING_TIME_ENTRY = 'REVERT_ENGINEERING_TIME_ENTRY';

export const UPSERT_ENGINEERING_TIME_ENTRY_SUCCESS =
  'UPSERT_ENGINEERING_TIME_ENTRY_SUCCESS';
export const UPSERT_ENGINEERING_TIME_ENTRY_ERROR =
  'UPSERT_ENGINEERING_TIME_ENTRY_ERROR';
